module.exports = __webpack_public_path__ + "img/48.f10baf30.png";